import { render } from "./주차.vue?vue&type=template&id=970dd078"
import script from "./주차.vue?vue&type=script&lang=js"
export * from "./주차.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__